import { Component, type ReactNode } from "react";

interface Props { children: ReactNode; }
interface State { hasError: boolean; error: Error | null; errorInfo: string; }

const CHUNK_RELOAD_KEY = "chunk_boundary_reload";

function isDynamicChunkError(error: Error | null) {
  const message = String(error?.message || "");
  return (
    message.includes("Failed to fetch dynamically imported module") ||
    message.includes("Loading chunk") ||
    message.includes("Loading CSS chunk")
  );
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null, errorInfo: "" };

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("ErrorBoundary caught:", error, info);

    if (typeof window !== "undefined" && isDynamicChunkError(error)) {
      if (!sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
        sessionStorage.setItem(CHUNK_RELOAD_KEY, "1");
        window.location.reload();
        return;
      }
    }

    this.setState({
      errorInfo: info.componentStack || "",
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 40, fontFamily: "monospace", background: "#1a1a2e", color: "#e94560", minHeight: "100vh" }}>
          <h1 style={{ fontSize: 24, marginBottom: 16 }}>⚠️ NIPSYS — Erro de Renderização</h1>

          <div style={{ background: "#16213e", padding: 20, borderRadius: 8, marginBottom: 16 }}>
            <strong style={{ color: "#fff" }}>Erro (error.message):</strong>
            <pre style={{ color: "#ff6b6b", whiteSpace: "pre-wrap", marginTop: 8 }}>
              {this.state.error?.message || "(vazio — React minificado apagou)"}
            </pre>
          </div>

          <div style={{ background: "#16213e", padding: 20, borderRadius: 8, marginBottom: 16 }}>
            <strong style={{ color: "#fff" }}>Component Stack:</strong>
            <pre style={{ color: "#94a3b8", whiteSpace: "pre-wrap", marginTop: 8, fontSize: 12 }}>
              {this.state.errorInfo}
            </pre>
          </div>

          <button 
            onClick={() => { localStorage.clear(); window.location.href = "/login"; }}
            style={{ marginTop: 20, padding: "10px 20px", background: "#e94560", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontSize: 14 }}
          >
            Limpar sessão e voltar ao login
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
